/**
 * Configuración de la aplicación web.
 *
 * ---------------------------------------------------------------------------
 * POR QUÉ EXISTE ESTE ARCHIVO
 * ---------------------------------------------------------------------------
 * La dirección del backend estaba escrita a mano como "http://localhost:3001"
 * en 19 archivos distintos. Eso funciona mientras se desarrolla, pero rompe
 * la aplicación en cuanto se publica en un servidor: el código se ejecuta en
 * el NAVEGADOR de cada persona, así que "localhost" no es el servidor de la
 * empresa, es el computador de quien está mirando la pantalla.
 *
 * Ahora la dirección se define en un solo sitio y sale de una variable de
 * entorno que se fija ANTES de compilar.
 *
 * ---------------------------------------------------------------------------
 * CÓMO SE CONFIGURA
 * ---------------------------------------------------------------------------
 * Create React App congela el valor de REACT_APP_API_URL dentro del paquete
 * compilado en el momento de ejecutar `npm run build`. No se puede cambiar
 * después editando un archivo en el servidor: hay que volver a compilar.
 *
 *   Desarrollo  -> si no se define nada, se usa http://localhost:3001
 *   Producción  -> crear frontend/.env.production con:
 *                    REACT_APP_API_URL=https://assamas.assaabloy.com
 *                  y compilar con `npm run build`
 *
 * Ver frontend/.env.example y DESPLIEGUE.md en la raíz del proyecto.
 */

/** Quita las barras finales para que al concatenar no queden "//" en la URL. */
const sinBarraFinal = (url) => String(url || "").replace(/\/+$/, "");

export const API_BASE_URL = sinBarraFinal(
  process.env.REACT_APP_API_URL || "https://assamas.assaabloy.net"
);

/**
 * Las imágenes y documentos subidos se guardaron en la base de datos con la
 * dirección completa del servidor del momento (por ejemplo
 * "http://localhost:3001/assets/posts/foto.png"). Si el dominio cambia —al
 * publicar, al pasar a HTTPS o al mudar de servidor— esas rutas quedan
 * apuntando a un sitio que ya no existe y las fotos salen rotas.
 *
 * Esta función reescribe el origen de cualquier ruta de /assets al servidor
 * actual, así que el contenido histórico se sigue viendo sin tener que
 * migrar la base de datos.
 */
export const urlDeArchivo = (ruta) => {
  if (!ruta) return ruta;
  const texto = String(ruta);

  // Ruta relativa ("/assets/...") -> se le antepone el backend actual.
  if (texto.startsWith("/")) return `${API_BASE_URL}${texto}`;

  // Ruta absoluta hacia /assets -> se le cambia el origen por el actual.
  const marca = "/assets/";
  const posicion = texto.indexOf(marca);
  if (posicion !== -1 && /^https?:\/\//i.test(texto)) {
    return `${API_BASE_URL}${texto.slice(posicion)}`;
  }

  // Cualquier otra cosa (data:, una URL externa) se deja intacta.
  return texto;
};
